import * as React from 'react';
import PropTypes from 'prop-types';

const Globe = ({ stylingWhite }) => (
    <svg
        fill='none'
        height='15'
        viewBox='0 0 15 15'
        width='15'
        xmlns='http://www.w3.org/2000/svg'><path
            d='M7.125.125c-3.863 0-7 3.137-7 7s3.137 7 7 7 7-3.137 7-7-3.137-7-7-7Zm-3.786 7c0-.649.062-1.283.155-1.87h3.415v4.002H3.54c-.124-.68-.2-1.39-.2-2.132ZM7.341.573c1.515.155 2.813 1.87 3.323 4.234H7.34zM6.91 4.807H3.586C4.096 2.443 5.38.727 6.91.573zm0 4.883v3.987c-1.468-.14-2.72-1.746-3.26-3.987zm.432 0h3.26c-.556 2.24-1.792 3.832-3.26 3.987zm0-.448V5.255h3.415c.108.587.155 1.221.155 1.87 0 .742-.077 1.453-.201 2.132 0 0-3.369 0-3.369-.015Zm3.848-3.987h2.225c.186.587.278 1.221.278 1.87 0 .742-.123 1.453-.355 2.132h-2.194c.123-.664.2-1.39.2-2.132 0-.649-.046-1.283-.154-1.87Zm2.07-.448h-2.163C10.741 3.061 9.968 1.624 8.964.82c1.978.588 3.585 2.071 4.296 3.987ZM5.287.82c-1.004.804-1.777 2.241-2.148 3.987H.975A6.64 6.64 0 0 1 5.286.82ZM.836 5.255H3.06a12 12 0 0 0-.155 1.87c0 .742.078 1.453.201 2.132H.913a6.5 6.5 0 0 1-.355-2.132c0-.649.108-1.283.278-1.87Zm.247 4.435H3.2c.386 1.638 1.144 2.967 2.086 3.74a6.62 6.62 0 0 1-4.203-3.74Zm7.88 3.724c.943-.757 1.7-2.101 2.087-3.74h2.117c-.773 1.809-2.302 3.2-4.203 3.74Z'
            fill='#fff'
            stroke={`${stylingWhite ? '#FFFFFF' : '#FC5200'}`}
            strokeMiterlimit='10'
            strokeWidth='.25' /></svg>
);

const propTypes = {
    stylingWhite: PropTypes.string
};

Globe.propTypes = propTypes;

export default Globe;
